import React from 'react';
import { Snackbar } from '@mui/material';
import { useEditProductForm } from './useEditProductForm';
import { FormHeader } from './components/FormHeader';
import { ProductDetailsSection } from './components/ProductDetailsSection';
import { PricingSection } from './components/PricingSection';
import { ClassificationSection } from './components/ClassificationSection';
import { MediaSection } from './components/MediaSection';
import { PromotionsSection } from './components/PromotionsSection';
import { ToppingsSection } from './components/ToppingsSection';
import { IngredientsSection } from './components/IngredientsSection';
import { ActionFooter } from './components/ActionFooter';
import { StatusUpdateSection } from './components/StatusUpdateSection';
import ErrorFormAlert from '../ErrorForm';
import styles from './components/styles.module.css';

const KitchenListEditProductForm = ({ product, onClose, onUpdate, onRefresh }) => {
  const form = useEditProductForm({ product, onUpdate, onClose });

  return (
    <div ref={form.formTopRef} className={styles.formWrapper}>
      <FormHeader
        product={product}
        productType={form.productType}
        changedCount={form.changedCount}
        onClose={onClose}
      />

      <div className={styles.formBody}>
        {form.missingFields.length > 0 && (
          <div className={styles.errorWrapper}>
            <ErrorFormAlert data={form.missingFields} fullWidth />
          </div>
        )}

        <ProductDetailsSection
          productName={form.productName}
          setProductName={form.setProductName}
          recipeWith={form.recipeWith}
          setRecipeWith={form.setRecipeWith}
          description={form.description}
          setDescription={form.setDescription}
          selectedDays={form.selectedDays}
          setSelectedDays={form.setSelectedDays}
          errors={form.errors}
          editingFields={form.editingFields}
          startEdit={form.startEdit}
          cancelField={form.cancelField}
          onChangeHandler={form.onChangeHandler}
        />

        <PricingSection
          price={form.price}
          quantity={form.quantity}
          setQuantity={form.setQuantity}
          servingTemperature={form.servingTemperature}
          setServingTemperature={form.setServingTemperature}
          errors={form.errors}
          editingFields={form.editingFields}
          startEdit={form.startEdit}
          cancelField={form.cancelField}
          onChangeHandler={form.onChangeHandler}
          trackField={form.trackField}
        />

        <ClassificationSection
          productCategory={form.productCategory}
          setProductCategory={form.setProductCategory}
          specialMarking={form.specialMarking}
          setSpecialMarking={form.setSpecialMarking}
          cuisineType={form.cuisineType}
          setCuisineType={form.setCuisineType}
          size={form.size}
          setSize={form.setSize}
          categoryList={form.categoryList}
          editingFields={form.editingFields}
          startEdit={form.startEdit}
          cancelField={form.cancelField}
          trackField={form.trackField}
        />

        <MediaSection
          imageFile={form.imageFile}
          setImageFile={form.setImageFile}
          previewUrl={form.previewUrl}
          setPreviewUrl={form.setPreviewUrl}
          showIngredientImage={form.hasIngredientImageFromProduct}
          ingredientImageFile={form.ingredientImageFile}
          setIngredientImageFile={form.setIngredientImageFile}
          ingredientPreviewUrl={form.ingredientPreviewUrl}
          setIngredientPreviewUrl={form.setIngredientPreviewUrl}
        />

        {form.productType === 'non_meal_item' && <PromotionsSection offers={form.offers} />}

        {form.productType === 'non_meal_item' && (
          <ToppingsSection
            extraToppings={form.extraToppings}
            setExtraToppings={form.setExtraToppings}
          />
        )}

        <IngredientsSection
          ingredients={form.ingredients}
          allergicIngredients={form.allergicIngredients}
        />

        <ActionFooter
          editConfirmed={form.editConfirmed}
          setEditConfirmed={form.setEditConfirmed}
          fieldsToBeUpdatedUnique={form.fieldsToBeUpdatedUnique}
          isLoading={form.isLoading}
          onClose={onClose}
          handleUpdateProduct={form.handleUpdateProduct}
        />

        <StatusUpdateSection onRefresh={onRefresh} product={product} />
      </div>

      <Snackbar
        open={form.openSnackBar}
        autoHideDuration={5000}
        onClose={() => form.setOpenSnackBar(false)}
        message="Product updated successfully!"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        className="order-snackbar"
      />
    </div>
  );
};

export default KitchenListEditProductForm;
